import { InfoMessage } from '@fasstech/middle-design-system';
import { useWatch } from 'react-hook-form';
import {
  RECOMMENDATION_INTRO_MESSAGE,
  RECOMMENDATION_MESSAGES
} from '@@custom/garance/__custom/constants/recommendationMessages.mjs';

const SELECTED_FIELDS_BY_CODE = {
  OPTION_TT_CAUSE: 'guarantees.OPTION_TT_CAUSE.selected',
  OPTION_ACC: 'guarantees.OPTION_ACC.selected',
  OPTION_INCAP: 'guarantees.OPTION_INCAP.selected',
  OPTION_FR_GEN: 'guarantees.OPTION_FR_GEN.selected',
  OPTION_INVAL: 'guarantees.OPTION_INVAL.selected'
};

const SimulationPricingsSelfWorkerExtraRecommendationMessages = ({
  form,
  guarantees,
  getMiddleBoolean
}) => {

  const watchedValues = useWatch({
    control: form.control,
    name: RECOMMENDATION_MESSAGES.map(
      recommendation => SELECTED_FIELDS_BY_CODE[recommendation.code]
    )
  });

  const {
    GAR_DECEASED_PTIA,
    GAR_INCAP,
    GAR_INVAL
  } = guarantees;

  const isDeathSectionVisible =
    getMiddleBoolean('NIVEAUXGARANTIESETTARIFS_GAR_DECES_EST_NECESSAIRE') &&
    GAR_DECEASED_PTIA &&
    getMiddleBoolean('NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_EST_NECESSAIRE');

  const isIncapSectionVisible =
    getMiddleBoolean('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_INVAL_EST_NECESSAIRE') &&
    GAR_INCAP &&
    getMiddleBoolean('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_EST_NECESSAIRE');

  const isInvalSectionVisible =
    getMiddleBoolean('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_INVAL_EST_NECESSAIRE') &&
    GAR_INVAL &&
    getMiddleBoolean('NIVEAUXGARANTIESETTARIFS_GAR_INVAL_EST_NECESSAIRE');

  const selectedByCode = RECOMMENDATION_MESSAGES.reduce((acc, recommendation, index) => {
    acc[recommendation.code] = watchedValues?.[index] === true;
    return acc;
  }, {});

  const isRecommendationVisible = code => {
    switch (code) {
      case 'OPTION_TT_CAUSE':
      case 'OPTION_ACC':
        return isDeathSectionVisible;

      case 'OPTION_INCAP':
        return isIncapSectionVisible;

      case 'OPTION_FR_GEN':
        return isIncapSectionVisible && selectedByCode.OPTION_INCAP;

      case 'OPTION_INVAL':
        return isInvalSectionVisible;

      default:
        return false;
    }
  };

  const activatedMessages = RECOMMENDATION_MESSAGES
    .filter(recommendation => {
      const selected = selectedByCode[recommendation.code] === true;
      const visibleInScreen = isRecommendationVisible(recommendation.code);

      return selected && visibleInScreen;
    })
    .map(recommendation => recommendation.message);

  return (
    <InfoMessage iconName="lightbulb" className="w-full mb-4">
      <div>
        <p>{RECOMMENDATION_INTRO_MESSAGE}</p>

        <ul className="list-disc pl-6 mt-2">
          {activatedMessages.map(message => (
            <li key={message}>{message}</li>
          ))}
        </ul>
      </div>
    </InfoMessage>
  );
};

export default SimulationPricingsSelfWorkerExtraRecommendationMessages;
